import './App.scss';

export const Info = () => {
  return (
    <div className="info">
      <div className="parts">
        <span className="part title"><div className="box" /><h1>Hi,</h1></span>
        <span className="part">My name is Felix Tilli, and I'm a lead developer and partner at <a href="https://spintr.com" target="_blank">Spintr</a>.</span>
        <span className="part">I like simplicity.</span>
        <span className="part italic">.NET, C#, Azure, JavaScript, TypeScript, CSS, React, React Native, SQL, MongoDB.</span>
        <span className="part links">
          <a href="https://github.com/felixtilli" target="_blank">
            <img src={process.env.PUBLIC_URL + "/github.svg"} />
          </a>
          <a href="https://www.linkedin.com/in/felixtilli/" target="_blank">
            <img src={process.env.PUBLIC_URL + "/linkedin.svg"} />
          </a>
        </span>
      </div>
    </div>
  );
}
